import Controller from "@ember/controller";

export default class ChatChannelIndexController extends Controller {}
